import React from 'react';
import Select from 'material-ui-beta/Select';
import TextField from 'material-ui-beta/TextField';
import {MenuItem} from 'material-ui-beta/Menu';
const LocalDate = require('js-joda').LocalDate;
import Card, {CardContent} from 'material-ui-beta/Card';
import Button from 'material-ui-beta/Button';
import {CircularProgress} from 'material-ui-beta/Progress';

import api from '../../api/api';
import GoogleHeatMap from '../google-heat-map';

import './index.css';

class AdminQueryReport extends React.Component {

    state = {
        loading: false,
        specialties: null,
        medications: null,
        adminReport: null,
        selectedSpecialty: null,
        selectedMedication: null,
        startDate: LocalDate.now().minusWeeks(1),
        endDate: LocalDate.now().plusDays(1)
    };

    componentDidMount() {
        const {startDate, endDate} = this.state;

        Promise.all([api.fetchSpecialties(), api.fetchMedicationsAvailable(), api.fetchAdminReport(startDate.toString(), endDate.toString())]).then(([specialties, medications, adminReport]) => {
            let medicationList = [];
            let options = specialties.val().options;
            let groups = medications.val().groups;
            let groupOptions = Object.keys(groups).map(key => groups[key].options);
            groupOptions.forEach(values => {
                Object.keys(values).forEach(key => {
                    medicationList.push({ key, name: values[key].name});
                });
            });

            this.setState({
                specialties: sortAlphabetically(Object.keys(options).map(key => ({key, name: options[key].name}))),
                medications: sortAlphabetically(medicationList),
                adminReport,
                points: adminReport.data.map(item => parsePoint(item)),
                totalSearches: adminReport.data.length
            });
        });
    }

    onSelectChange = (event) => {
        console.log("onSelectChanged", event.target);
        this.setState({
            [event.target.name]: event.target.value !== "-1" ? event.target.value : null
        });
    };

    onDateChange = (event) => {
        this.setState({
            [event.target.id]: LocalDate.parse(event.target.value)
        });
    };

    onUpdateClick = () => {
        this.setState({
            loading: true
        });

        const {startDate, endDate, selectedSpecialty, selectedMedication} = this.state;
        api.fetchAdminReport(startDate.toString(), endDate.toString(), selectedSpecialty, selectedMedication).then(response => {
            console.log("response", response.data);
            this.setState({
                loading: false,
                adminReport: response.data,
                points: response.data.map(item => parsePoint(item)),
                totalSearches: response.data.length
            });
        })
    };

    render() {
        const {totalSearches} = this.state;

        if (this.state.specialties) {
            return (
                <div className="admin-query-report-container flex1 flex column">
                    <div className="admin-query-report-controls">
                        <Card>
                            <CardContent>
                                <div className="flex">
                                    <div>
                                        <TextField
                                            id="startDate"
                                            label="Start Date"
                                            type="date"
                                            onChange={this.onDateChange}
                                            defaultValue={this.state.startDate.toString()} />
                                    </div>
                                    <div className="marginLeft30">
                                        <TextField
                                            id="endDate"
                                            label="End Date"
                                            type="date"
                                            onChange={this.onDateChange}
                                            defaultValue={this.state.endDate.toString()} />
                                    </div>
                                    <div className="marginLeft30">
                                        <div className="admin-query-report-label">
                                            Specialty
                                        </div>
                                        <div>
                                            <Select name="selectedSpecialty" onChange={this.onSelectChange} value={this.state.selectedSpecialty || "-1"}>
                                                <MenuItem value="-1">
                                                    Choose Specialty
                                                </MenuItem>
                                                {this.state.specialties.map((specialty, index) => {
                                                    return (
                                                        <MenuItem key={`specialty-${specialty.key}`} value={specialty.key}>
                                                            {specialty.name}
                                                        </MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="marginLeft30">
                                        <div className="admin-query-report-label">
                                            Medication
                                        </div>
                                        <div>
                                            <Select name="selectedMedication" onChange={this.onSelectChange} value={this.state.selectedMedication || "-1"}>
                                                <MenuItem value="-1">
                                                    Choose Medication
                                                </MenuItem>
                                                {this.state.medications.map((medication, index) => {
                                                    return (
                                                        <MenuItem key={`medication-${medication.key}`} value={medication.key}>
                                                            {medication.name}
                                                        </MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="marginLeft30">
                                        <div className="admin-query-report-label">
                                            # Searches
                                        </div>
                                        <div className="marginTop10">
                                            {totalSearches}
                                        </div>
                                    </div>
                                    <div className="marginLeft30 flex1 flex column justifyCenter alignEnd">
                                        {this.state.loading ?
                                            <CircularProgress size={35} />
                                            :
                                            <Button variant="raised" color="primary" onClick={this.onUpdateClick}>Update</Button>
                                        }

                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                    <div className="flex1 relative">
                        <GoogleHeatMap data={this.state.points} />
                    </div>
                </div>
            )
        }
        return (
            <div className="admin-query-report-container flex center">
                <div className="marginTop30">
                    <CircularProgress size={45} />
                </div>
            </div>
        )

    }
}

function sortAlphabetically(list) {
    list.sort((item1, item2) => item1.name.localeCompare(item2.name));
    return list;
}

function parsePoint(item) {
    let point = item.point.value.match(/POINT\(([^ ]+) ([^)]+)\)/);
    return {
        lat: point[2],
        lng: point[1]
    };
}

export default AdminQueryReport;


// WEBPACK FOOTER //
// ./src/components/admin-query-report/index.js